import * as React from "react"
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {Box, CircularProgress, Divider, FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import Slider from "react-slick";
import NavBar from "../components/NavBar";
import {
    addCommas,
    convertPrice,
    handleBorderColor,
    HandleValidationMethod,
    removeNonNumeric,
    useShowMessageComponent
} from "../assets/js/main";
import {setPriceBox} from "../redux/singleOrder/infoBox/actions";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../redux/loading/actions";
import HandleFetchData from "../plugin/HandleFetchData";
import {setValidations} from "../redux/public/actions";


export default function BuyCarton(props) {
    const {t} = useTranslation()
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const {fetchData} = HandleFetchData()
    const selector = useSelector((st) => st)
    const {validationMethod} = HandleValidationMethod()
    const {showMessageComponent} = useShowMessageComponent()

    const [count, setCount] = React.useState('0')
    const [cartonList, setCartonList] = React.useState([])
    const [payMethods, setPayMethods] = React.useState([]);
    const [paymentMethod, setPaymentMethod] = React.useState("Payments.Wallet");
    const [shipmentNo, setShipmentNo] = React.useState("");
    const [_totalPrice, _setTotalPrice] = React.useState(0);
    const [listSelect, setlistSelect] = React.useState([]);


    React.useEffect(() => {
        handleGetCartonList()
        getPaymentMethods()
    }, [])

    const validationInput = () => {
        (!shipmentNo) ?
            validationMethod('', 'shipmentNo', t("error.t61"))
            :
            !paymentMethod ?
                validationMethod('', 'paymentMethod', t("error.t30"))
                : submitBuyCarton()
    }

    const handleGetCartonList = async () => {
        let fetch = await fetchData('', 'GET', '/getCartonListAndPayment', '',
            "application/json", '', 'postex'
        )
        setCartonList(fetch?.Data?.ProductDetailsModel?.ProductAttributes[0]?.Values)
        dispatch(setLoading(false))
    }

    const getPaymentMethods = async () => {
        let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
            "application/json", {
                "orderId": "0",
                "paymentMethodForId": "2"
            }, '', ''
        )
        if (fetch?.Data) {
            setPayMethods(fetch?.Data)
        }
    }


    const handleSetCount = (c, p, i) => {
        let list = [...cartonList]
        list[i].Quantity = c
        list[i]['totalPrice'] = p * c

        let _listSelect = [...listSelect]
        if (c > 0) {
            _listSelect?.push({
                "Id": list[i]?.Id,
                "Name": list[i]?.Name,
                "Count": list[i]?.Quantity
            })
        }else{
            _listSelect = listSelect?.filter(e => e.Id !== list[i]?.Id)
        }

        setlistSelect(_listSelect)

        setCartonList(list)
        handleTotalPrice(list)
    }

    const handleTotalPrice = (l) => {
        let total = 0
        l?.map(item => total = total + (item?.totalPrice || 0))
        _setTotalPrice(total)
    }

    const handleGetWHL = (text, type) => {
        const text1 = text?.split('(')
        const text2 = text1[1]?.split(')')
        const text3 = text2[0]?.split('*')
        return type === 'l' ? text3[0] : type === 'w' ? text3[1] : (text3?.length > 2 ? text3[2] : '-')
    }


    const submitBuyCarton = async () => {
        dispatch(setValidations(null))
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'POST', '/CartonSaleAndpayment', {
                "Amount": Math.round(_totalPrice),
                "OrderId": 0,
                "ShipmentId": Number(shipmentNo),
                "UseRewardPoints": paymentMethod === "Payments.Wallet",
                "paymentmethod": paymentMethod,
                "List_Sizeitem": listSelect
            },
            "application/json", '', 'postex'
        )

        if(fetch?.IsSuccess){
            if (paymentMethod != "Payments.Wallet"){
                window.open(fetch?.Data, '_self');
            }else{
                await showMessageComponent(t("msg.t5"), 'success')
            }
            setTimeout(() => {
                window.location.reload();
            }, 2000)
        }
        dispatch(setLoading(false))
    }

    return (
        <>
            <NavBar/>

            <div className="cartoonPage">
                <div className="container">
                    <div className="cartoonList">
                        <h2>{t("cartoon.t5")}</h2>
                        <div className="">
                            <div className="row">
                                {
                                    cartonList?.map((item, index) => {
                                        return <div className="col-12 col-md-6 col-lg-4 mb-4">
                                            <div className="item">
                                                <div className="info">
                                                    <div className="desc">
                                                        <p>{item?.Name}</p>
                                                        <span>{t("cartoon.t7") + ' ' + handleGetWHL(item?.Name, 'l')} cm</span>
                                                        <span>{t("cartoon.t8") + ' ' + handleGetWHL(item?.Name, 'w')} cm</span>
                                                        <span>{t("cartoon.t9") + ' ' + handleGetWHL(item?.Name, 'h')} cm</span>
                                                    </div>
                                                    <div className="img">
                                                        <img src={item?.ImageSquaresPictureModel?.ImageUrl}
                                                             alt={t("cartoon.t6") + (index + 1)}
                                                             loading="lazy"/>
                                                    </div>
                                                </div>
                                                <Divider/>
                                                <div className="price">
                                                    <p>{t("packing.t25")}</p>
                                                    <span>{convertPrice(Math.round(cartonList[index]?.PriceAdjustmentValue)) + ' ' + t("packing.t4")}</span>
                                                </div>
                                                <Divider/>
                                                <div className="count">
                                                    <label
                                                        className="">{t("singleOrder.invoice.t7")}</label>
                                                    <input type="text" autoComplete="on"
                                                           id="countBox"
                                                           inputMode='numeric' className="numeric"
                                                           value={item?.count}
                                                           onChange={e => handleSetCount(removeNonNumeric(e.target.value), cartonList[index]?.PriceAdjustmentValue, index)}/>

                                                    {
                                                        selector?.public?.validations?.count &&
                                                        <p className="error">{selector?.public?.validations?.count}</p>
                                                    }
                                                </div>
                                                <Divider/>
                                                <div className="price">
                                                    <p>{t("dashboard.order.t12")}</p>
                                                    <span>{convertPrice(Math.round(item?.totalPrice)) + ' ' + t("packing.t4")}</span>
                                                </div>
                                            </div>

                                        </div>
                                    })
                                }
                            </div>

                            <div className="row invoice">
                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="input">
                                        <label className="required">{t("dashboard.order.t28")}</label>
                                        <input type="text" autoComplete="on"
                                               id="countBox"
                                               inputMode='numeric' className="numeric mb-1"
                                               value={shipmentNo}
                                               onChange={e => setShipmentNo(removeNonNumeric(e.target.value))}/>

                                        {
                                            selector?.public?.validations?.shipmentNo &&
                                            <p className="error">{selector?.public?.validations?.shipmentNo}</p>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3">
                                    <div className="info">
                                        <p>{t("paymentStatus.t3")}: </p>
                                        <p> {convertPrice(Math.round(_totalPrice)) + ' ' + t("packing.t4")} </p>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3">
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={paymentMethod}
                                            onChange={(event) => setPaymentMethod(event.target.value)}
                                            id="paymentMethod"
                                        >
                                            {
                                                payMethods?.PaymentMethods?.map((item, index) =>
                                                    item?.Name !== "بانک سامان" &&
                                                    <FormControlLabel value={item?.PaymentMethodSystemName}
                                                                      control={<Radio/>}
                                                                      label={item?.Name + ' ' + `${item?.PaymentMethodSystemName === "Payments.Wallet"
                                                                          ? `( ${(payMethods?.RewardPointsBalance ?
                                                                              convertPrice(payMethods?.RewardPointsBalance) : 0) + ' ' + t("singleOrder.invoice.t14")} )` : ''}`}/>
                                                )
                                            }
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 payment">
                                    <div className="btnGroup_yellow m-0">
                                        <button className="btnFill" disabled={selector?.loading?.isLoading}
                                                onClick={validationInput} id="validationInput">
                                            {
                                                selector?.loading?.isLoading ?
                                                    <Box sx={{display: 'flex'}}>
                                                        <CircularProgress size={20}/>
                                                    </Box>
                                                    :
                                                    <span>{t("wallet.t23")}</span>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
